import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBadgeCheck, faChevronRight, faFile } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-home-company-summary',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './home-company-summary.component.html',
})
export class HomeCompanySummaryComponent {
  @Input() progress = 0;
  @Input() documentCount = 0;

  @Output() completeRequested = new EventEmitter<void>();

  readonly faFile = faFile;
  readonly faChevronRight = faChevronRight;
  readonly faBadgeCheck = faBadgeCheck;

  get progressOffset(): number {
    return 2 * 3.14159 * 42 * (1 - this.progress / 100);
  }
}
